import cx from 'classnames';
import HeroHeader from 'modules/common/HeroHeader';
import LoadingIndicator from 'modules/common/LoadingIndicator';
import NextButton from 'modules/common/NextButton';
import {getDisqusAccessToken} from 'modules/user/actions/disqus-token.js';
import PropTypes from 'prop-types';
import React, {lazy, Suspense, useEffect} from 'react';
import {useIntl} from 'react-intl';
import {connect} from 'react-redux';
import {updateVideoProgress} from '../actions/updateVideoProgress';
import ShareVideoTutorials from '../components/VideoTutorial/ShareVideoTutorials';
import TabbedContent from '../components/VideoTutorial/TabbedContent';
import VideoWrapper from '../components/VideoTutorial/VideoWrapper';
import {f2remM} from './styles.scss';

const Highlight = lazy(() => import('modules/common/Highlight'));

const VideoTutorial = (props) => {
  useEffect(() => {
    props.disqusAccessToken();
  });
  const intl = useIntl();
  const {formatMessage} = intl;
  const {
    authenticated,
    completeProgress,
    nextStepProps,
    step,
    stepProgress,
    updateProgress,
    accessToken,
    trackSlug,
    isDegree,
    trackTopicName,
  } = props;
  return (
    <>
      <Suspense fallback={<LoadingIndicator />}>
        <Highlight force />
      </Suspense>
      <HeroHeader title={step.name} trackSlug={trackSlug} isDegree={isDegree} />
      <VideoWrapper
        autoplay={authenticated}
        className="mb5"
        nextStepProps={nextStepProps}
        stepId={step.id}
        stepProgress={stepProgress}
        updateProgress={updateProgress}
        videoId={authenticated && step.videotutorial.videoYoutubeId}
        trackSlug={trackSlug}
      />
      <div className="pv2 tr pr3">
        <h3 className={cx(f2remM, 'f3')}>{step.name}</h3>
        <TabbedContent
          videoId={step.videotutorial.videoYoutubeId}
          isDisplayRepl={step.videotutorial.isDisplayRepl}
          description={step.videotutorial.description}
          downloads={step.videotutorial.resourceSet}
          note={step.videotutorial.teacherNote}
          access_token={accessToken}
          trackSlug={trackSlug}
          stepId={step.id}
          trackTopicName={trackTopicName}
        />
        {!isDegree && <ShareVideoTutorials />}
      </div>
      <div className="pv5 pb5 pl6-ns pl0 tc tl-ns">
        <NextButton
          pretext={`${formatMessage({
            id: 'continue',
          })} :`}
          completeProgress={completeProgress}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...nextStepProps}
          stepId={step.id}
        />
      </div>
    </>
  );
};

VideoTutorial.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  completeProgress: PropTypes.func.isRequired,
  nextStepProps: PropTypes.object.isRequired,
  updateProgress: PropTypes.func.isRequired,
  step: PropTypes.shape({
    videotutorial: PropTypes.shape({
      resourceSet: PropTypes.shape({
        edges: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string.isRequired,
            resourceUrl: PropTypes.string.isRequired,
            fileType: PropTypes.string,
          }),
        ),
      }),
      isDisplayRepl: PropTypes.bool.isRequired,
      description: PropTypes.string,
      teacherNote: PropTypes.string,
      videoYoutubeId: PropTypes.string.isRequired,
    }).isRequired,
    id: PropTypes.number,
    status: PropTypes.string.isRequired,
    name: PropTypes.string,
    stage: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),

    score: PropTypes.number,
  }).isRequired,
  stepProgress: PropTypes.string.isRequired,
  accessToken: PropTypes.string,
  trackSlug: PropTypes.string,
  isDegree: PropTypes.bool.isRequired,
  trackTopicName: PropTypes.string.isRequired,
  relatedSteps: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  disqusAccessToken: PropTypes.func,
};

const mapStateToProps = ({user: {progress, accessToken}}, ownProps) => ({
  stepProgress:
    (progress.step && progress.step[ownProps.step.id]) || 'not started',
  accessToken: accessToken.data.disqus_sso_key,
});

const mapDispatchToProps = (dispatch, {relatedSteps, step: {id}}) => ({
  updateProgress: (completed) => {
    dispatch(updateVideoProgress({id, completed, related_steps: relatedSteps}));
  },
  completeProgress: () => {
    dispatch(
      updateVideoProgress({id, completed: true, related_steps: relatedSteps}),
    );
  },
  disqusAccessToken: () => {
    dispatch(getDisqusAccessToken());
  },
});

const enhance = connect(mapStateToProps, mapDispatchToProps);

export default enhance(VideoTutorial);
